module.exports = __webpack_public_path__ + "static/media/virtualreality.30b1b790.svg";